module.exports = __webpack_public_path__ + "img/reservation.38b87761.svg";